import { Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { ElementInterface, UserElementsFragment, UserElementsGQL } from "@/core/graphql/graphql";
import { CosmosDialogService, CosmosDialogStyle } from "@/core/services/cosmos-dialog.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  ElementDetailsModalComponent,
} from "@/modules/elements/components/element-details-modal/element-details-modal.component";
import { Column } from "@/shared/components/table/table.model";
import {
  UserElementsDatasource,
} from "@/modules/users/components/user-details-modal/components/user-elements/user-elements.datasource";
import {
  USER_ELEMENTS_COLUMNS,
} from "@/modules/users/components/user-details-modal/components/user-elements/user-elements.const";

@Component({
  selector: 'cosmos-user-elements',
  templateUrl: './user-elements.component.html',
  styleUrls: ['./user-elements.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserElementsComponent implements OnInit, OnDestroy {
  @ViewChild('contentTemplate', { static: true }) public contentTemplate: TemplateRef<ElementInterface>;
  @ViewChild('checkboxTemplate', { static: true }) public checkboxTemplate: TemplateRef<ElementInterface>;

  public _columns: Column<UserElementsFragment>[] = [];
  public _dataSource: UserElementsDatasource;
  public _loading$: Observable<boolean>;
  private readonly _subscription: Subscription = new Subscription();

  public constructor(
    private readonly _userElementsGql: UserElementsGQL,
    private readonly _dialog: CosmosDialogService,
    @Inject(MAT_DIALOG_DATA) private readonly _data: { userId: number },
  ) {
    this._dataSource = new UserElementsDatasource(_userElementsGql, this._data.userId);
    this._loading$ = this._dataSource._loading$;
  }

  public ngOnInit(): void {
    this._columns = USER_ELEMENTS_COLUMNS(this.checkboxTemplate, this.contentTemplate);
    this._dataSource.loadData(null);
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public openElementDetails(data: UserElementsFragment): void {
    this._dialog.open<ElementDetailsModalComponent, { elementId: number }>(
      ElementDetailsModalComponent,
      {
        data: {
          elementId: data.id,
        },
        style: CosmosDialogStyle.Dark,
      });
  }
}
